export enum ls {
  SANDBOX = 'sandboxMode',
  ORG_ID = 'org',
  TENANT_ID = 'tenant_id',
  USER = 'user',
  ENTITY_ID = 'treez_entity_id',
  REDIRECT_ORG_ID = 'redirect_org_id',
  IS_ORG_LEVEL = 'is_org_level',
  ORG_CONTEXT = 'org_context',
  SELECTED_ENTITY_IDS = 'selected_entity_ids',
}

const orgLevelSubscribers = new Set<() => void>();

export const subscribeIsOrgLevel = (callback: () => void): (() => void) => {
  orgLevelSubscribers.add(callback);
  return () => {
    orgLevelSubscribers.delete(callback);
  };
};

const notifyIsOrgLevel = (): void => {
  orgLevelSubscribers.forEach((callback) => callback());
};

const accessLocalStorage = {
  getOrgId: (): string => localStorage.getItem(ls.ORG_ID) || '',
  setOrgId: (orgId: string): void => {
    try {
      localStorage.setItem(ls.ORG_ID, orgId);
    } catch (e) {
      // eslint-disable-next-line
      console.log(e);
    }
  },
  setEntityId: (entity_id: string) => {
    try {
      localStorage.setItem(ls.ENTITY_ID, entity_id);
    } catch (e) {
      // eslint-disable-next-line
      console.log(e);
    }
  },
  getEntityId: (): string => localStorage.getItem(ls.ENTITY_ID) || '',
  getSandboxMode: (): boolean => localStorage.getItem(ls.SANDBOX) === 'true',
  setSandboxMode: (mode: boolean): void =>
    localStorage.setItem(ls.SANDBOX, mode.toString()),

  getUser: () => JSON.parse(localStorage.getItem(ls.USER) ?? '{}'),
  setUser: (user: Record<string, unknown>): void => {
    try {
      localStorage.setItem(ls.USER, JSON.stringify(user));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  },
  updateUser: (patch: Record<string, unknown>): void => {
    try {
      const current = JSON.parse(localStorage.getItem(ls.USER) ?? '{}');
      const defined = Object.fromEntries(
        Object.entries(patch).filter(([, value]) => value !== undefined)
      );
      localStorage.setItem(ls.USER, JSON.stringify({ ...current, ...defined }));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  },
  setRedirectOrgId: (org_id: string) => {
    try {
      localStorage.setItem(ls.REDIRECT_ORG_ID, org_id);
    } catch (e) {
      console.log(e);
    }
  },
  getRedirectOrgId: (): string =>
    localStorage.getItem(ls.REDIRECT_ORG_ID) || '',

  setIsOrgLevel: (isOrgLevel: boolean): void => {
    try {
      localStorage.setItem(ls.IS_ORG_LEVEL, isOrgLevel.toString());
    } catch (e) {
      console.log(e);
    }
    notifyIsOrgLevel();
  },
  getIsOrgLevel: (): boolean => {
    try {
      return localStorage.getItem(ls.IS_ORG_LEVEL) === 'true';
    } catch (e) {
      console.log(e);
      return false;
    }
  },

  setOrgContext: (orgContext: Record<string, unknown>): void => {
    try {
      localStorage.setItem(ls.ORG_CONTEXT, JSON.stringify(orgContext));
    } catch (e) {
      console.log(e);
    }
  },
  getOrgContext: (): Record<string, unknown> | null => {
    try {
      const context = localStorage.getItem(ls.ORG_CONTEXT);
      return context ? JSON.parse(context) : null;
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  setSelectedEntityIds: (entityIds: string[]): void => {
    try {
      localStorage.setItem(ls.SELECTED_ENTITY_IDS, JSON.stringify(entityIds));
    } catch (e) {
      console.log(e);
    }
  },
  getSelectedEntityIds: (): string[] => {
    try {
      const ids = localStorage.getItem(ls.SELECTED_ENTITY_IDS);
      return ids ? JSON.parse(ids) : [];
    } catch (e) {
      console.log(e);
      return [];
    }
  },

  clear: (): void => localStorage.clear(),
  clearItem: (key: ls): void => localStorage.removeItem(key),
};

export default accessLocalStorage;
